import Splide from '@splidejs/splide';
import { isMobile } from './isMobile';

let popupSliderOptions;

if (!isMobile()) {
    popupSliderOptions = {
        type: 'slide',
        perPage: 3,
        perMove: 1,
        focus: 'center',
        trimSpace: false,
        arrows: true,
        start: 1,
        pagination: false,
        gap: '',
        autoHeight: true,
        autoWidth: true,
        speed: 300
    };
} else {
    popupSliderOptions = {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        focus: 'center',
        trimSpace: false,
        arrows: true,
        start: 1,
        pagination: false,
        gap: '',
        autoHeight: true,
        autoWidth: true,
        speed: 300
    }
}
let popupSlider = new Splide('#video-slider', popupSliderOptions).mount();
var slider = document.getElementById('video-slider');

popupSlider.on('move', function () {
    if (document.querySelector('.right-slide')) {
        document.querySelector('.right-slide').classList.remove('right-slide');
    }

    if (document.querySelector('.left-slide')) {
        document.querySelector('.left-slide').classList.remove('left-slide');
    }
});
popupSlider.on('moved', function (newIndex, oldIndex) {
    if (document.querySelector('.popup .splide__slide.is-active').nextElementSibling) {
        document.querySelector('.popup .splide__slide.is-active').nextElementSibling.classList.add('right-slide');
    }

    if (document.querySelector('.popup .splide__slide.is-active').previousElementSibling) {
        document.querySelector('.popup .splide__slide.is-active').previousElementSibling.classList.add('left-slide');
    }

    var target = newIndex > oldIndex ? slider.querySelector('.splide__arrow--next') : slider.querySelector('.splide__arrow--prev');
    if (!target.classList.contains('animate')) {
        target.classList.add('animate');
        setTimeout(() => {
            target.classList.remove('animate');
        }, 1600);
    }
    if (currentPlayer) {
        currentPlayer.stopVideo();
        var playerId = document.querySelectorAll('#video-slider .player')[newIndex].id;
        if (players[playerId]) {
            currentPlayer = players[playerId];
        }
    }
    if (window.openingVideo) {
        var video = document.querySelectorAll('#video-slider .lazy-video')[newIndex];
        var videoId = video.querySelector('.player').id;
        if (players[videoId]) {
            currentPlayer = players[videoId];
            currentPlayer.playVideo();
        }
        else {
            video.dispatchEvent(new Event('click'));
        }
        window.openingVideo = false;
    }
});

let closePopupBtn = document.querySelector('.close-popup');
let storyLinks = document.querySelectorAll('.story-link');
closePopupBtn.addEventListener('click', () => {
    document.querySelector('.popup').classList.remove('show');
    document.body.classList.remove('open-popup');
    storyLinks.forEach(el => {
        el.classList.remove('open-popup');
    });
    if (currentPlayer) {
        currentPlayer.stopVideo();
    }
});

var apiLoaded = false;
var currentPlayer;
var players = {};

document.querySelectorAll('#video-slider .lazy-video').forEach(self => {
    self.addEventListener('click', () => {
        var videoId = self.getAttribute('video-id');
        var playerId = self.querySelector('.player').id;
        if (!apiLoaded) {
            window.onYouTubeIframeAPIReady = function () {
                loadPlayer(videoId, playerId)
            };

            var tag = document.createElement('script');

            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            apiLoaded = true;
        }
        else {
            loadPlayer(videoId, playerId);
        }
    });
})

function loadPlayer(videoId, playerId) {
    currentPlayer = players[playerId] = new YT.Player(playerId, {
        videoId: videoId,
        events: {
            'onReady': function (event) {
                event.target.playVideo();
            }
        }
    })
}

export default popupSlider;